import { Box, Text, VStack } from "@chakra-ui/react";
import { Field, FormInput, FormSelect, CollapsibleSection, ItemCard, ItemHeader, AddButton, RepeatableText, Grid2, isFieldInvalid, isFieldWarning } from "@/components/jobOffer/ui";
import { createEmptyConversionGoal } from "@/models/campaign";

const GOAL_TYPE_OPTIONS = [
    { value: "Purchase", label: "Zakup produktu" },
    { value: "Registration", label: "Rejestracja na usługę" },
    { value: "Meeting", label: "Umówienie spotkania" },
    { value: "Form", label: "Formularz" },
    { value: "HandoffToHuman", label: "Przekazanie do handlowca" },
];

const CALENDAR_SYSTEM_OPTIONS = [
    { value: "CalCom", label: "Cal.com" },
    { value: "Microsoft365", label: "Microsoft 365" },
    { value: "GoogleCalendar", label: "Google Calendar" },
    { value: "Other", label: "Inny system (API)" },
];

const Step4ConversionGoal = ({ formik, values, setValues, warningErrors, visited, forceOpen }) => {
    const set = (key, val) => setValues({ ...values, [key]: val });

    const goalsInvalid = isFieldInvalid(formik, "conversionGoals");
    const goalsWarning = !goalsInvalid && isFieldWarning(warningErrors, visited, "conversionGoals");
    const goals = values.conversionGoals ?? [];
    const setGoals = (next) => set("conversionGoals", next);
    const updateGoal = (i, patch) => setGoals(goals.map((g, idx) => idx === i ? { ...g, ...patch } : g));
    const removeGoal = (i) => setGoals(goals.filter((_, idx) => idx !== i));
    const addGoal = () => setGoals([...goals, createEmptyConversionGoal()]);

    return (
        <VStack w="full" align="stretch" gap={4}>
            <CollapsibleSection title="Cele kampanii" subtitle="Do czego Agent ma dążyć w rozmowie" defaultOpen forceOpen={forceOpen}>
                <VStack align="stretch" gap={4}>
                    {goals.length === 0 && (
                        <Text
                            fontSize="xs"
                            fontWeight={goalsInvalid || goalsWarning ? 600 : 400}
                            color={goalsInvalid ? "red.400" : goalsWarning ? "orange.500" : "text.grey"}
                        >
                            Dodaj co najmniej jeden cel konwersji, żeby aktywować kampanię.
                        </Text>
                    )}
                    {goals.map((g, i) => (
                        <ItemCard key={i}>
                            <ItemHeader title={GOAL_TYPE_OPTIONS.find(o => o.value === g.goalType)?.label ?? "Cel"} index={i} onRemove={() => removeGoal(i)} />
                            <VStack align="stretch" gap={3}>
                                <Field label="Typ celu" required>
                                    <FormSelect value={g.goalType} onChange={(v) => updateGoal(i, { goalType: v })} options={GOAL_TYPE_OPTIONS} placeholder="Wybierz typ" />
                                </Field>
                                <Field label="Link" hint="np. link do zakupu/rejestracji/kalendarza">
                                    <FormInput value={g.link ?? ""} onChange={(e) => updateGoal(i, { link: e.target.value })} />
                                </Field>
                                {g.goalType === "Meeting" && (
                                    <Grid2>
                                        <Field label="System kalendarza">
                                            <FormSelect value={g.calendarSystem ?? ""} onChange={(v) => updateGoal(i, { calendarSystem: v || null })} options={CALENDAR_SYSTEM_OPTIONS} placeholder="Wybierz system" />
                                        </Field>
                                        <Field label="Link do kalendarza">
                                            <FormInput value={g.calendarLink ?? ""} onChange={(e) => updateGoal(i, { calendarLink: e.target.value })} placeholder="np. https://cal.com/..." />
                                        </Field>
                                    </Grid2>
                                )}
                                <RepeatableText label="Preferowane CTA dla tego celu" values={g.preferredCta ?? []} onChange={(v) => updateGoal(i, { preferredCta: v })} placeholder="np. Umów prezentację" />
                            </VStack>
                        </ItemCard>
                    ))}
                    <AddButton label="Dodaj cel konwersji" onClick={addGoal} />
                    <Box borderWidth={1} borderColor="border.primary" borderRadius={8} p={3} bg="bg.highlight">
                        <Text fontSize="xs" color="text.grey">
                            Agent nie pokazuje CTA mechanicznie po każdej odpowiedzi — prezentuje je dopiero, gdy rozpozna moment gotowości zakupowej klienta.
                        </Text>
                    </Box>
                </VStack>
            </CollapsibleSection>
        </VStack>
    );
};

export default Step4ConversionGoal;
